import { render, staticRenderFns } from "./EditSimpleLookupComponent.vue?vue&type=template&id=164f1c33&scoped=true&"
import script from "./EditSimpleLookupComponent.vue?vue&type=script&lang=js&"
export * from "./EditSimpleLookupComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditSimpleLookupComponent.vue?vue&type=style&index=0&id=164f1c33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164f1c33",
  null
  
)

export default component.exports